import {QuantidadeComponenteKit} from './QuantidadeComponenteKit';
export class ConfigComponenteKit {
  modalidadeQuantidade: 'FIXA' | 'FECHADA' | 'ESCOLHIDA_PELO_CLIENTE' = 'FIXA';
  qtdeFixa = 100;
  qtdeMinima = 100;
  qtdeMaxima: number = null;
  incremento = 10;
  qtdeMinimaPorOpcao = 1;
  qtdeMaximaDeOpcoes: number = null;
  cobranca: 'INCLUIDO' | 'POR_QUANTIDADE' = 'INCLUIDO';
  preco = 0;
  precoReferencia = 0;
  qtdeReferencia = 100;
  quantidades: QuantidadeComponenteKit[] = [];
}

